import React, { PureComponent } from 'react'
import { compose } from 'recompose'
import { Title } from 'components/misc'
import { Header, LayoutPlain } from 'components/layout'
import { meta } from 'helpers/decorators'

const enhance = compose(
  meta({
    title: 'Participant registration fees payment',
    intlKey: 'moduleTitle.payment'
  })
)

class ParticipantReviewDenied extends PureComponent {
  static propTypes = {

  }

  render() {
    return (
      <LayoutPlain greyBg header={<Header />}>
        <Title
          h1
          intlKey="moduleTitle.registration_not_exist"
          className="base-margin--top"
        >
          Registration does not exist
        </Title>

      </LayoutPlain>
    )
  }
}

export default enhance(ParticipantReviewDenied)
